import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import EditEllipses from './edit-ellipses';
import { GreenroomState } from '../../stores/types/types';
import { setHomeMeeting } from '../../stores/actions/home';
import { setMeetingModalOpen, setMeetingToEdit } from '../../stores/actions/session';
import type { Meeting } from '../../stores/types/session';
import { setModalState } from '../../stores/actions/modal';
import { MODAL_TEMPLATES } from '../../stores/reducers/modal';
import { APP } from '../../stores/session-status';

interface IEventMenuProps {
	event: { [key: string]: any };
}

export default function EventMenu({ event }: IEventMenuProps): JSX.Element {
    const events: { [key: string]: any }[] = useSelector((state: GreenroomState) => state.ContentReducer.events);
    const appSignedInWith = useSelector((state: GreenroomState) => state.SessionReducer.appSignedInWith);

    const dispatch = useDispatch();

	const modifyEvent = async (event: { [key: string]: any }, type: string) => {
		if (event) {
			const { meeting } = event;

			switch (type) {
				case 'edit':
					if (events.length) {
						let matchingEvent = null;

						if (meeting) {
							matchingEvent = events.find((event) => event.meeting === meeting);
						}

						if (matchingEvent) {
							dispatch(setHomeMeeting(matchingEvent));
							dispatch(setMeetingToEdit(matchingEvent as Meeting));
							dispatch(setMeetingModalOpen(true));
						}
					}

					break;
				case 'copy':
					dispatch(setModalState({
						modalOpen: true,
						modalTemplate: MODAL_TEMPLATES.COPY_EVENT,
						modalData: {
							sourceMeeting: event
						}
					}));

					break;
				case 'remove':
					dispatch(setModalState({
						modalOpen: true,
						modalTemplate: MODAL_TEMPLATES.DELETE_EVENT_CONFIRMATION,
						modalData: {
							meeting: event
						}
					}));

					break;
				default:
					break;
			}
		}
	};

	return (
        <EditEllipses
            editCallback={() => {
                if (modifyEvent) {
                    modifyEvent(event, 'edit');
                }
            }}
            copyCallback={() => {
                if (modifyEvent) {
                    modifyEvent(event, 'copy');
                }
            }}
            deleteCallback={() => {
                if (modifyEvent) {
                    modifyEvent(event, 'remove');
                }
            }}
            showEditDelete={appSignedInWith === APP.GREENROOM}
        ></EditEllipses>
	);
}
